import {blueColor, DodgerBlueColor} from '../../cmsMainStyle'

const propertyDetailFormStyle = theme => ({
	root: {
		'& .MuiTextField-root': {
			marginTop: theme.spacing(2),
		},
	},

	paperBox: {
		  marginTop: theme.spacing(3),
	  },

	paper: {
		backgroundColor: blueColor[1],
		padding: theme.spacing(1),
		minHeight: theme.spacing(30)
	},

	addFileIcon: {
		textAlign: "right"
	},

	attachmentToolbar: {
		textAlign: "right"
	},

	attachmentBtn: {
		margin: "2px",
		backgroundColor: DodgerBlueColor[11],
		'&:hover': {
			background: DodgerBlueColor[13],
		},
	},

	detailInformation: {
		height: window.outerHeight - (window.outerHeight - window.innerHeight + 90),
		overflowY: "auto",
		overflowX: "hidden"
	},

	webviewer: {
		height: window.outerHeight - (window.outerHeight - window.innerHeight + 90)
	},

	fileList: {
		marginTop: theme.spacing(2),
		paddingLeft: theme.spacing(1.5),
		paddingRight: theme.spacing(1.5),
	},

	fileUploadBtnArea: {
		textAlign: "center",
		paddingTop: theme.spacing(1),
		paddingBottom: theme.spacing(1),
	},

	fileUploadBtn: {
		backgroundColor: DodgerBlueColor[11],
		'&:hover': {
			background: DodgerBlueColor[13],
		},
	},

	datePickerField: {
		width: '100%',
	},
})


export {propertyDetailFormStyle}